import React, { useState, useEffect, useCallback } from "react";
import * as S from "./styles";

import EyeImg from "assets/passwordEye.svg";

import Input from "../../../Input";
import MaskedInput from "../../../MaskedInput";

import { useUserRegister } from "contexts/register/UserContext";
import Select from "../../../Select";
import { isEmailValid } from "utils/isEmailValid";
import { getUserService } from "services/UserServices";

type Props = {
  isEditing: boolean;
  setRole: (value: string) => void;
};

export function UserForm({ isEditing, setRole }: Props) {
  const { user, errors, searching, addError, removeError, setUser } =
    useUserRegister();
    const [confirmPassword, setConfirmPassword] = useState('');

  const roles = [
    {
      id: "21aa3d03-a4c3-4cd3-aa6f-852cfe037ef0",
      name: "Operador",
      initials: "OPE",
    },
    {
      id: "6048f43b-e92d-4414-9443-ef735ef0033a",
      name: "Administrador",
      initials: "MST",
    },
    {
      id: "e192d5a2-7795-4f4b-aaeb-1b7a173f9f15",
      name: "Gestor Financeiro",
      initials: "FIN",
    },
  ];

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");

  const checkIfUserExist = useCallback(async () => {
    try {
      const userExist = await getUserService({ where: { email } });

      if (userExist.status) {
        addError("emailExists", "E-mail já registrado");
        return;
      }
    } catch {
      removeError("emailExists");
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  useEffect(() => {
    if (isEmailValid(email)) {
      checkIfUserExist();
    }
  }, [email, checkIfUserExist]);

  function validateCPF(event: React.ChangeEvent<HTMLInputElement>) {
    const cpf = event.target.value.replace("_", "");
    if (cpf.length < 14) {
      addError("cpf", "CPF inválido");
      return;
    }

    removeError("cpf");
  }

  function validateRG(event: React.ChangeEvent<HTMLInputElement>) {
    const rg = event.target.value.replace("_", "");
    if (rg.length < 12) {
      addError("rg", "RG inválido");
      return;
    }

    removeError("rg");
  }

  function handleConfirmPassword(){
    if (user.password !== confirmPassword){
      addError("confirmedPassword", "As senhas nao sao iguais")
      return;
    }
    removeError("confirmedPassword")
  }

  // useEffect(() => {
  // handleConfirmPassword()
  // }, [confirmPassword])

  function validateEmail(event: React.ChangeEvent<HTMLInputElement>) {
    const email = event.target.value;

    if (!isEmailValid(email)) {
      addError("email", "E-mail inválido");
      return;
    }

    removeError("email");
  }
  if (searching) {
    return (
      <S.LoadingWrapper>
        <span>Buscando dados do usuário...</span>
      </S.LoadingWrapper>
    );
  }

  return (
    <S.Wrapper>
      <S.Form>
        <Input
          defaultValue={user.name}
          id="name"
          name="name"
          onChange={(event) => {
            setUser((_value) => {
              _value.name = event.target.value;
              return _value;
            });
          }}
          label="Nome completo"
          required={true}
          type="text"
          error={errors["user.name"]}
          apiErrorName={"user.name"}
          handleApiErrorRemove={() => removeError("user.name")}
        />
        <Input
          id="email"
          name="email"
          onBlur={validateEmail}
          defaultValue={user.email}
          onChange={(event) => {
            setEmail(event.target.value);
            setUser((_value) => {
              _value.email = event.target.value;
              return _value;
            });
          }}
          label="E-mail"
          required={true}
          type="email"
          error={errors.email || errors["users.email"] || errors["user.email"]}
          apiErrorName={"user.email"}
          handleApiErrorRemove={() => removeError("user.email")}
        />
        <S.DocumentContainer>
          <MaskedInput
            defaultValue={user.cpf}
            id="CPF"
            name="CPF"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUser((_value) => {
                _value.cpf = event.target.value;
                return _value;
              });
            }}
            onBlur={validateCPF}
            label="CPF"
            required={true}
            type="text"
            mask="999.999.999-99"
            error={errors.cpf || errors["users.cpf"] || errors["user.cpf"]}
            duplicatedError={errors["users.cpf"]}
            apiErrorName={"cpf"}
            handleApiErrorRemove={() => removeError("user.cpf")}
          />
          <MaskedInput
            id="RG"
            defaultValue={user.rg}
            name="RG"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUser((_value) => {
                _value.rg = event.target.value;
                return _value;
              });
            }}
            label="RG"
            onBlur={validateRG}
            required={true}
            type="text"
            mask="99.999.999-*"
            error={errors.rg || errors["user.rg"]}
            duplicatedError={errors["users.rg"]}
            apiErrorName={"user.rg"}
            handleApiErrorRemove={() => removeError("user.rg")}
          />
        </S.DocumentContainer>

        {!isEditing && (
          <>
            <Select
              id="role"
              name="role"
              value={user.role}
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                setRole(event.target.value);
                setUser((_value) => {
                  _value.role = event.target.value;
                  return _value;
                });
              }}
              defaultValue="x"
              // defaultValue={user.role === roles[0].id ? 'Operador' : (user.role === roles[1].id ? 'Administrador' : (user.role === roles[2].id ? 'X' : 'Selecione um cargo'))}
              label="Cargos"
              required={true}
              onBlur={() => removeError("user.role")}
              error={errors["user.role"]}
            >
              <option key={1} value={"empty"}>
                Selecione um cargo
              </option>
              {roles.map((role) => {
                return (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                );
              })}
            </Select>
              <S.PasswordContainer>
              <Input
              id="password"
              name="password"
              defaultValue={user.password}
              onChange={(event) => {
                setUser((_value) => {
                  _value.password = event.target.value;
                  return _value;
                });
              }}
              onBlur={() => {
                handleConfirmPassword()
              }}
              label="Senha"
              required={true}
              type={showPassword ? "text" : "password"}
              error={errors.password || errors["user.password"]}
              apiErrorName={"user.password"}
              handleApiErrorRemove={() => removeError("user.password")}
            />
            <Input
              id="confirmPassword"
              name="confirmPassword"
              defaultValue={confirmPassword}
              onChange={(event) => {
                if (errors.confirmedPassword) handleConfirmPassword();
                setConfirmPassword(event.target.value)
              }}
              onBlur={() => {
                handleConfirmPassword()
              }}
              label="Confirme sua senha"
              required={true}
              type={showPassword ? "text" : "password"}
              error={errors.confirmedPassword || errors["confirmedPassword"]}
            />
             <S.ViewPasswordButton
              type="button"
              onClick={() => setShowPassword(!showPassword)}
            ><img src={EyeImg} alt="Ícone de olho" /></S.ViewPasswordButton>

              </S.PasswordContainer>
          </>
        )}
      </S.Form>
    </S.Wrapper>
  );
}
